import { type TourStep } from '../interfaces';

import {
  CustomerDetailsStep,
  CannedResponsesStep,
  ReplySuggestionsStep,
  TagsStep,
  ChatsListStep,
  BubbleStep,
} from './tour-steps';

import * as styles from './styles';
export enum SampleChatTourSteps {
  Bubble = 'bubble',
  ChatsList = 'chats-list-column',
  CustomerDetails = 'customer-details-column',
  CannedResponses = 'canned-responses',
  ReplySuggestions = 'reply-suggestions',
  Tags = 'tags',
}

export const sampleChatSteps: TourStep[] = [
  {
    id: SampleChatTourSteps.Bubble,
    bubbleStepContent: BubbleStep,
    isFirstStep: true,
    className: styles.sampleChatBubbleTourStep,
    cursorTiming: 'moderate2',
  },

  {
    id: SampleChatTourSteps.ChatsList,
    stepContent: ChatsListStep,
    placement: 'right',
    elementClassName: styles.chatsListStepStyles,
    typingAnimation: true,
  },
  {
    id: SampleChatTourSteps.CustomerDetails,
    stepContent: CustomerDetailsStep,
    placement: 'left-start',
    elementClassName: styles.tourStepStylesWithRadius,
    typingAnimation: true,
  },

  {
    id: SampleChatTourSteps.CannedResponses,
    stepContent: CannedResponsesStep,
    placement: 'right',
    elementClassName: styles.tourStepStylesBase,
    typingAnimation: true,
  },
  {
    id: SampleChatTourSteps.ReplySuggestions,
    stepContent: ReplySuggestionsStep,
    placement: 'top',
    elementClassName: styles.replySuggestionsStepStyles,
    typingAnimation: true,
  },
  {
    id: SampleChatTourSteps.Tags,
    stepContent: TagsStep,
    placement: 'top',
    elementClassName: styles.tagsStepStyles,
    typingAnimation: true,
  },
];
